import { getAkResourcesStatus } from '../../services';
import useOverviewCheck from './useOverviewCheck';
import OverviewCardShell from './OverviewCardShell';

export default function AkResourcesCard() {
  const { data, isLoading, error } = useOverviewCheck(getAkResourcesStatus);

  return (
    <OverviewCardShell title="AK Resources" isLoading={isLoading} error={error} good={data?.good}>
      {data && !data.error && (
        <div className="space-y-1 text-sm text-slate-700">
          <p>
            {!data.eaaaau_good && '⚠️ '}
            EAAAAU: <span className="font-bold">{data.eaaaau_live}</span> LIVE
            <span className="text-xs text-slate-400"> / {data.eaaaau_wait} WAIT</span>
          </p>
          <p>
            {!data.eaagno_good && '⚠️ '}
            EAAGNO: <span className="font-bold">{data.eaagno_live}</span> LIVE
            <span className="text-xs text-slate-400"> / {data.eaagno_wait} WAIT</span>
          </p>
          <p>
            COST: <span className="font-bold">{data.cost.toFixed(2)}</span>
          </p>
          {data.best_products?.length > 0 && (
            <p className="text-xs text-slate-400">
              {data.best_products.map((p) => `${p.est_cost.toFixed(2)}::${p.web}`).join(' | ')}
            </p>
          )}
        </div>
      )}
      {data?.error && <p className="text-sm text-red-600">{data.error}</p>}
    </OverviewCardShell>
  );
}
